module.exports = __webpack_public_path__ + "static/img/xinwenmoren.d02fb68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinwenmoren.png
// module id = e0vm
// module chunks = 2